import parking2 from '../../../images/parkingZoom2.png';
import parking3 from '../../../images/parkingZoom3.png';
import lockbox2 from '../../../images/lockbox2.jpg';
import lockbox3 from '../../../images/lockbox3.jpg';
import lockbox4 from '../../../images/lockbox4.jpg';
import lockbox5 from '../../../images/lockbox5.jpg';
import lockbox6 from '../../../images/lockbox6.jpg';
import lockbox7 from '../../../images/lockbox7.jpg';
import lockbox8 from '../../../images/lockbox8.jpg';
import uberApp1 from '../../../images/uberApp1.png';
import uberApp2 from '../../../images/uberApp2.png';
import uberApp3 from '../../../images/uberApp3.png';

export const newDriverFaqData = [
  {
    content: [
      {
        title: 'Step 1',
        info: [
          {
            link: {
              leadingText: 'When your Autzu account is Active, you may visit ',
              title: 'www.autzu.com/book',
              href: '/book',
              trailingText: ' and reserve a time slot to drive',
            },
          },
          {
            list: {
              items: [
                'Rent 4, 8, 12, and even up to 16 hours per day.',
                'Total of 6 set start/end times: 3AM, 7AM, 11AM, 3PM, 7PM, 11PM.',
                'Pick up at the start time and drop off at the end time at the downtown Toronto parking lot.',
                'You can book in short notice or as far ahead as you want, it just depends on availability of cars.',
              ],
            },
          },
        ],
      },
      {
        title: 'Step 2',
        info: [
          {
            text: { content: 'Pack the things you need to bring before going to the parking lot:' },
          },
          {
            list: {
              items: [
                'Your smartphone with Uber Driver app installed and data plan;',
                'Phone mount/holder;',
                'USB charging cable for your smartphone;',
                'Drivers License (usually in wallet);',
                'Uber Beacon (if you have one).',
              ],
            },
          },
          {
            text: {
              title: 'TIP!',
              content:
                'Get a smartphone data plan from a large provider such as Telus, Rogers, or Bell. Discount providers like Chatr or Freedom are not as reliable and may not have such good coverage.',
            },
          },
        ],
      },
      {
        title: 'Step 3',
        info: [
          {
            text: {
              content:
                'Arrive at the parking lot: Omni Park Facility at the Thompson Residences - 621 King St. West. The closest intersection is Bathurst St. and King. St. West.',
            },
          },
          {
            text: {
              title: 'By walking:',
              content:
                'Follow the sign to the underground parking elevator for direct access to the parking lot. Autzu vehicles are parked on P4 (Level D). The elevator is accessible 24/7 and no fob is required.',
            },
          },
          {
            image: [
              {
                src: parking2,
                alt: 'parking2',
              },
            ],
          },
          {
            text: {
              title: 'By driving:',
              content:
                'If you drive your own car to the parking lot, you may park it for free in the same spot you pick up the Autzu car while you are working. Enter through the parking lot ramp and the gate will open automatically. Drive down to P4 (Level D) and you must park in the designated parking spot you pick up the Autzu car from.',
            },
          },
          {
            image: [
              {
                src: parking3,
                alt: 'parking3',
              },
            ],
          },
          {
            text: {
              content:
                '10 minutes before the start time of your booking, a car will be automatically assigned to you, and you will receive a text message with details such as:',
            },
          },
          {
            list: {
              items: ['Make, model, license plate of car;', "Where it's parked;", 'How to retrieve the key.'],
            },
          },
        ],
      },
      {
        title: 'Step 4',
        info: [
          {
            text: {
              content:
                'Inspect the assigned Autzu car for any unlabeled damage or low fuel. If the car is back late or there are any issues with the car, make a report.',
            },
          },
        ],
      },
      {
        title: 'Step 5',
        info: [
          {
            text: {
              content: 'Pick up the key in the lockbox.',
            },
          },
          {
            text: {
              content:
                'All lock boxes are opened by a 5-digit lock code which you will receive in a text message. To operate the lock boxes, follow these instructions:',
            },
          },
          {
            text: {
              title: 'Open the black cover flap to expose the number code pad.',
            },
          },
          {
            image: [
              {
                src: lockbox2,
                alt: 'lockbox2',
              },
              {
                src: lockbox3,
                alt: 'lockbox3',
              },
            ],
          },
          {
            text: {
              title: 'Reset the lock box by pressing the black lever (between 0 and *) so it makes a click noise.',
            },
          },
          {
            image: [
              {
                src: lockbox4,
                alt: 'lockbox2',
              },
            ],
          },
          {
            text: {
              title:
                'Type 5-digit lock box code and then push the large top silver lever button down and the box will open so you can retrieve the car key.',
            },
          },
          {
            image: [
              {
                src: lockbox5,
                alt: 'lockbox2',
              },
              {
                src: lockbox6,
                alt: 'lockbox3',
              },
            ],
          },
          {
            text: {
              title:
                'To close the box after retrieving the car key, reset the lock box code by pressing the black lever (between 0 and *) so it makes a click noise again',
            },
          },
        ],
      },
      {
        title: 'Step 6: Drive and Earn!',
        info: [
          {
            text: {
              content:
                'When you are ready to start driving, choose the correct vehicle plate in your Uber Driver app and go online.',
            },
          },
          {
            text: {
              title: 'VIDEO: How to access the vehicle list in Uber Driver app to choose the correct vehicle plate.',
            },
          },
          {
            video: {
              src: 'https://www.youtube.com/embed/GbD5NzM0FRE',
            },
          },
          {
            text: {
              content: 'You can also choose the types of trips you prefer to get by toggling them on or off.',
            },
          },
          {
            text: {
              content: "Tap on the bottom bar when you're in the main screen of Uber Driver App.",
            },
          },
          {
            image: [{ src: uberApp1, alt: 'uber-app' }],
          },
          {
            text: {
              content: 'You are in the Trip Planner page. Tap on the icon on the bottom right of the screen.',
            },
          },
          {
            image: [{ src: uberApp2, alt: 'uber-app' }],
          },
          {
            text: {
              content:
                "You will see the types of trips you can receive and you can toggle them on or off, don't forget to save your preferences by clicking SAVE.",
            },
          },
          {
            image: [{ src: uberApp3, alt: 'uber-app' }],
          },
          {
            text: {
              title: 'NOTE:',
              content:
                "When you drive Autzu PLUS, you won't see UberWAV or UberASSIST in this screen because those are available by default when you drive a PLUS van and you are not able to turn them off.",
            },
          },
        ],
      },
      {
        title: 'Step 7.',
        info: [
          {
            text: {
              content: '30 minutes before the end time of your booking, the system will send you an automated message.',
            },
          },
          {
            list: {
              items: [
                'If there is still availability, you can choose to extend your booking by an additional 4 hours by texting EXTEND back.',
                'If there is no availability, you will be reminded to refuel the tank to full and bring the car back on time.',
                'All cars take Regular 87 gas.',
              ],
            },
          },
        ],
      },
      {
        title: 'Step 8.',
        info: [
          {
            list: {
              items: [
                'Drop the car off, park in the same spot you picked up the car;',
                'Go offline in the Uber Driver app so that the following driver can go online on the same car later;',
                'Make sure that the key is back in the lockbox and closed properly. See below:',
              ],
            },
          },
          {
            text: { title: 'CLOSED CORRECTLY' },
          },
          {
            image: [{ src: lockbox7, alt: 'lockbox' }],
          },
          {
            text: { title: 'NOT CLOSED CORRECTLY' },
          },
          {
            image: [{ src: lockbox8, alt: 'lockbox' }],
          },
          {
            text: { title: 'NOTE: Failing to close the lock box correctly will result in a $100 fine.' },
          },
        ],
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/components/Static/NewDriverFaq/newDriverFaqData.js